import {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {
	userInfoService, versionReviewService, mediaShareService, mediaService, mediaVersionService, versionFilesService,
	versionTracksService
} from '_app/services';
import {Enums} from '_app/utils';
import MediaShare from './MediaShare';
import {getPublicSettings} from '_app/shared/features/officeSettings/officeSettingsActions';
import {publicOfficeInfoShape} from '_app/shapes';
import WithScrollToTop from '_app/shared/components/WithScrollToTop';
import storedFileService from '../../../services/storedFileService';

export class MediaShareContainer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			media: {},
			userInfo: {},
			review: {},
			source: {},
			tracks: [],
			isLoading: true,
			htmlContent: null,
			errorMessage: null
		};

		this.dataLoad = this.dataLoad.bind(this);
	}

	componentDidMount() {
		this.props.getPublicSettings(this.props.token);
		this.dataLoad();
	}

	componentDidUpdate() {
		if (this.state.media.name) {
			document.title = this.state.media.name;
		}
	}

	dataLoad() {
		const {token} = this.props;
		let {media} = this.state;

		userInfoService
			.fetchShareUser(token)
			.then(data => {
				this.setState({
					userInfo: data
				});

				return mediaShareService.getPublic(token);
			})
			.then(data => {
				this.setState({
					media: Object.assign({}, this.state.media, data)
				});

				return mediaService.getPublic(this.state.media.mediaID, token);
			})
			.then(data => {
				media = data;
				this.setState({
					media: Object.assign({}, this.state.media, data)
				});

				return mediaVersionService.latestPublic(this.state.media.mediaID, token);
			})
			.then(data => {
				media = Object.assign(media, data);
				this.setState({
					media: Object.assign({}, this.state.media, data)
				});

				return versionReviewService.shared(media.MediaID, media.Version, token);
			})
			.then(data => {
				this.setState({
					review: $.extend({}, data)
				});
				if (media.Type !== Enums.getType('mediaTypes').VIDEO) {
					return;
				}

				return this.videoSupportDataLoad(media.MediaID);
			})
			.done(() => {
				this.setState({
					isLoading: false
				});
			})
			.fail((jqXHR, message) => {
				// Client page does not need detail on what kind of error
				// occurred, any error aside from 500 interpreted as content no
				// longer available.
				message = 'This content is no longer available';
				if (jqXHR.status === 500) {
					message = 'Sorry, an error occurred trying to load this page';
				}
				this.setState({
					isLoading: false, errorMessage: message
				});
			});
	}

	fetchHtmlContent = async storedFileID => {
		const data = await storedFileService.getStringData(storedFileID);

		this.setState({
			htmlContent: data
		});
	}

	videoSupportDataLoad(mediaID) {
		const promises = [];
		const {token} = this.props;

		// Prevent when from resolving at any rejection.
		promises.push(versionFilesService
			.shared(token, mediaID)
			.then(data => {
				this.setState({
					source: data
				});
			})
		);
		promises.push(versionTracksService
			.shared(token, mediaID)
			.then(data => {
				this.setState({
					tracks: data
				});
			})
		);

		const deferreds = promises.map(function(item) {
			const d = $.Deferred();

			item.always(function() {
				d.resolve();
			});
			return d;
		});

		return $.when.apply(this, deferreds);
	}

	render() {
		return (
			<MediaShare
				media={this.state.media}
				userInfo={this.state.userInfo}
				office={this.props.office}
				errorMessage={this.state.errorMessage}
				htmlContent={this.state.htmlContent}
				isLoading={this.state.isLoading}
				review={this.state.review}
				source={this.state.source}
				tracks={this.state.tracks}
				token={this.props.token}
			/>
		);
	}
}

MediaShareContainer.propTypes = {
	token: PropTypes.string.isRequired,
	office: PropTypes.shape({
		isLoading: PropTypes.bool,
		data: publicOfficeInfoShape
	}),
	getSharedSettings: PropTypes.func
};

const mapStateToProps = ({office}) => ({
	office
});

const mapDispatchToProps = {
	getPublicSettings
};

export default WithScrollToTop(connect(mapStateToProps, mapDispatchToProps)(MediaShareContainer));